import { CommonService, Field } from '../common.service'
import { OpHistory } from '../../../models/custom/op-history'
import { OpFile } from '../../../models/core/op-file'
import { GridModel, GridRequestModel, HistoryModel, FileModel } from '../../api/api.models'
import { DataType, CommonHelper, ViewColumnType, } from '../../../helpers/common-helper'
import { DataProvider } from '../../../helpers/data-provider'
import { Enums } from '../../../models/common/enums'
import { IUserSession } from '../../../helpers/user-session'
import { LocalDictionaryFactory } from  '../../api/api.module'

export class HistoryService /*extends CommonService<OpHistory> */{
    private idTaskStatusColumnName: string;

    constructor(private localDictionary: LocalDictionaryFactory, private userSession: IUserSession) { }

    getHistoryForReport(id: number) {
        return this.userSession.getDataProvider().System.getHistory(id, Enums.ReferenceType.IdReport).then(result => {
            var model: HistoryModel[] = []
            result.forEach(h => {
                model.push(<HistoryModel>{
                    description: h.descr,
                    longDescription: h.longDescr,
                    eventDate: h.eventDate,
                    eventObject: h.eventObject,
                    objectHistoryEventType: h.objectHistoryEventType,
                    eventType: h.eventType.description
                })
            })
            return model
        })
    }

    getGenatedReportFile(id: number, fileName: string) {
        return this.userSession.getDataProvider().Report.getGeneratedReport(id, fileName).then(result => {
            var bytes = new Uint8Array(<number[]>result.fileBytes)
            var FileSaver = require('file-saver')
            var blob = new Blob([bytes], { type: 'application/octet-stream' });
            FileSaver.saveAs(blob, result.physicalFileName)
            return true
        })
    }
}